import { useNavigate } from 'react-router-dom';

import { useDisplayCategoryCreateMutation } from '@occc-app/dataAccessLayer/displayCategory/mutations';
import { DisplayCategoryCreateMutation } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';

import { CreateDisplayCategoryPage } from './CreateDisplayCategoryPage';

import { parseBannerIds, routeCreator, getShouldLazyLoadBannersForMutation } from '../utils';
import { DisplayCategoryFormValues } from '../types';
import { validateDisplayCategory } from '../validation';

export const CreateDisplayCategoryPageContainer = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const onCompleted = (mutation: DisplayCategoryCreateMutation) => {
    const id = mutation.displayCategoryCreate?.id;
    if (id) {
      navigate(routeCreator.details(id));
    }
  };
  const [createDisplayCategoryMutation] = useDisplayCategoryCreateMutation({ onCompleted });

  const create = (values: DisplayCategoryFormValues) => {
    const { name, rank, banners, categoryRestrictions, shouldLazyLoadBanners } = values;
    const isNoCategoryRestrictions = !categoryRestrictions || categoryRestrictions === 'None';
    const bannerIds = parseBannerIds(banners) || [];

    if (!name) {
      return;
    }

    return createDisplayCategoryMutation({
      variables: {
        input: {
          name,
          categoryRestrictions: isNoCategoryRestrictions ? null : categoryRestrictions,
          rank: rank || 0,
          chainId,
          bannerIds,
          shouldLazyLoadBanners: getShouldLazyLoadBannersForMutation(
            bannerIds,
            shouldLazyLoadBanners,
          ),
        },
      },
    });
  };

  return (
    <CreateDisplayCategoryPage createDisplayCategory={create} validate={validateDisplayCategory} />
  );
};
